/**
 * 成员调整部门
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IChangeDepartmentInput {
    umu_ids: string;
    department_ids: string;
}
export interface IChangeDepartmentOutput {
    status: number;
    desc: string;
}
export const changeMemberDepartment = (data: IChangeDepartmentInput) => {
    return fetchData(Api.CHANGE_MEMBER_DEPARTMENT, data).then((res: IResponse<IChangeDepartmentOutput>) => {
        return res.data;
    });
};
